import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'payment-refund-success-modal',
  templateUrl: './payment-refund-success-modal.component.html',
  styleUrls: ['./payment-refund-success-modal.component.scss'],
  standalone: false,
})
export class PaymentRefundSuccessModalComponent {
  constructor(public dialogRef: MatDialogRef<any>) {}

  onClose(): void {
    this.dialogRef.close();
  }
}
